<template>
  <div class="flex gap-6">
    <div class="card-holder" :class="{ inactive: isInactive }">
      <div class="card-hover-trigger">
        <div class="inner-card-holder" :class="{ active: isSelected }">
          <!-- Check Box Here -->
          <div class="checkbox-container-holder">
            <label class="checkbox-container">
              <input
                type="checkbox"
                @change="handleSelection(false, 'checkbox')"
                :checked="isSelected"
                :disabled="isInactive"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <!-- Image Here -->
          <div
            class="image-holder-container"
            @click="handleSelection(true, 'image')"
          >
            <div v-if="isHEIC" class="image-holder" id="target">
              <span v-if="imageUrl === null"> Loading... </span>
              <span v-else>
                <img
                  :src="imageUrl"
                  alt="image"
                  @error="handleBrokenImage($event)"
                />
              </span>
            </div>
            <div v-else class="image-holder">
              <img
                :src="product.image"
                alt="image"
                @error="handleBrokenImage($event)"
              />
            </div>
          </div>
        </div>

        <!-- Product Details Here -->
        <div class="product-details-container">
          <div class="product-details">
            <div class="flex flex-col gap-2 items-start justify-start">
              <p class="name">
                {{ product.name | capitalize }}
              </p>

              <span class="font-bold pt-2 name text-left capitalize">{{
                getSelectedVarient(
                  product.id,
                  isSelected && checkOptionsCount(product.option)
                )
              }}</span>
            </div>

            <p v-if="product.price">${{ product.price }}</p>
          </div>
          <div class="product-details description" :title="product.description">
            <p class="w-full">
              {{ product.description ? trimText(product.description) : 'N/A' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Here -->
    <section v-if="isOpen">
      <Modal
        color-variation="abstract-muted"
        :show-footer="false"
        :showXButton="true"
        :custom-styles="{ width: '700px', padding: '0 !important' }"
        :custom-wrapper-styles="{ padding: '20px' }"
        :isSelectOpen="isSelectOpen"
        @hideModal="isOpen = false"
        :showHeader="false"
      >
        <template #body>
          <section v-if="product.origin == 'projects'">
            <Singleproduct
              :product="product"
              :selectedItems="selected"
              @updateSelection="updateSelection"
              @selectItem="selectItem"
              @unSelectItem="unSelectItem"
              :isSelected="isSelected"
              @persistData="persistData"
              @isSelectOpen="value => (isSelectOpen = value)"
              @hideModal="isOpen = false"
            />
          </section>

          <section v-else>
            <RedemptionSingleProduct
              v-if="product.type == 'product'"
              :product="product"
              :selectedItems="selected"
              @unSelectItem="unSelectItem"
              :payload="selected"
              @selectItem="selectItem"
              @updateProductVariant="
                data => $emit('updateProductVariant', data)
              "
              @updateSelection="updateSelection"
              @persistData="closeModal"
              @isSelectOpen="value => (isSelectOpen = value)"
            />

            <RedemptionBundle
              v-else
              :product="product"
              :data="bundleData"
              :payload="selected"
              @unSelectItem="unSelectItem"
              @selectItem="selectItem"
              @updateProductVariant="
                data => $emit('updateProductVariant', data)
              "
              @persistData="closeModal"
              @isSelectOpen="value => (isSelectOpen = value)"
            />
          </section>
        </template>
      </Modal>
    </section>
  </div>
</template>

<script>
import { handleBrokenImage, defaultNotFoundImage } from '@/helpers'
import Modal from '../Modal'
import Singleproduct from './ProjectsSingleProduct'
import RedemptionSingleProduct from './RedemptionSingleProduct'
import RedemptionBundle from './RedemptionBundle'
import HEICConversion from '../../../mixins/HEICConversion'
export default {
  name: 'ProductTiersCard',
  mixins: [HEICConversion],
  components: {
    Modal,
    Singleproduct,
    RedemptionSingleProduct,
    RedemptionBundle
  },

  props: {
    limit: {
      type: Number,
      default: null
    },
    isAddressCollection: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Array,
      default: () => []
    },
    bundleData: {
      type: Object,
      default: () => ({})
    },
    tier: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    isOpen: false,
    isSelectOpen: false,
    handleBrokenImage: handleBrokenImage
  }),

  computed: {
    isSelected() {
      return !!this.selected.find(item => item.id === this.product.id)
    },

    isInactive() {
      if (this.tier) {
        const selectedInThisTier = this.selected.filter(
          item => parseInt(item.tierId) === parseInt(this.tier.id)
        )
        return selectedInThisTier.length === this.limit && !this.isSelected
      }
      return this.selected.length === this.limit && !this.isSelected
    }
  },
  mounted() {
    this.checkHEIC(this.product.image, this.product.fileType)
  },
  methods: {
    trimText(text) {
      if (window.innerWidth < 576) {
        return text.substring(0, 70) + '...'
      } else {
        return text.substring(0, 90) + '...'
      }
    },
    handleSelection(showModal = false, target) {
      if (
        this.selected.length === this.limit &&
        !this.selected.find(item => item.id === this.product.id)
      ) {
        return
      }

      if (this.isAddressCollection) {
        this.handleAddressCollection(target)
      } else {
        this.handleRedemption()
      }

      if (showModal) {
        this.isOpen = true
      }
    },

    handleAddressCollection(target) {
      const isImageClicked = target === 'image'
      const { option } = this.product
      const transformed = Object.values(option.length ? option[0] : {})
      const optionLength = transformed.length ? transformed[0].length : 0

      if (optionLength) {
        if (this.isSelected) {
          if (isImageClicked) {
            this.handleTimeOut(300, this.product)
          } else {
            this.$emit('handleSelectedItem', this.product)
          }
          return
        } else {
          if (isImageClicked) {
            this.handleTimeOut(300, this.product)
          } else {
            if (optionLength > 1) {
              this.handleTimeOut(300, this.product)
            } else {
              this.$emit('handleSelectedItem', this.product)
            }
          }
        }
      } else {
        if (!isImageClicked) {
          this.$emit('handleSelectedItem', this.product)
        }

        // if (!this.isSelected) {
        //   this.isOpen = true
        // } else {
        //   if (!isImageClicked) {
        //     this.$emit('handleSelectedItem', this.product)
        //   }
        // }
      }
    },
    handleRedemption() {
      this.$emit('handleSelectedItem', this.product)
      let { type } = this.product
      if (type === 'product') {
        let options = this.getVariantOptions(this.product)
        this.handleTimeOut(300, this.product)

        const defaultSeletedVariant = options[0]

        // select varaint
        this.$emit('updateProductVariant', {
          itemId: this.product.itemId,
          ...defaultSeletedVariant
        })
      } else {
        this.handleTimeOut(300, this.product)
      }
    },

    handleTimeOut(timeout, option) {
      setTimeout(() => {
        this.handleModal(option)
      }, timeout)
    },

    handleModal() {
      this.isOpen = true
    },

    closeModal() {
      this.isOpen = false
    },

    updateSelection({ id, option, value }) {
      this.$emit('updateSelection', id, option, value)
    },

    selectItem(product, closeModal = false) {
      const isSelected = this.selected.find(item => item.id === product.id)
      if (!isSelected) {
        this.$emit('handleSelectedItem', product)
      }
      if (closeModal) {
        this.closeModal()
      }
    },
    unSelectItem(product) {
      const isSelected = this.selected.find(item => item.id === product.id)
      if (isSelected) {
        this.$emit('unSelectItem', product)
      }
    },

    persistData(closeModal = false) {
      localStorage.setItem(
        'adminOrderSelectedItems',
        JSON.stringify(this.selected)
      )
      if (closeModal) {
        this.closeModal()
      }
    },

    getVariantOptions(product) {
      let options = []

      const availableProduct =
        product.itemableAttributes &&
        product.itemableAttributes.product_variants_list &&
        product.itemableAttributes.product_variants_list.data

      if (availableProduct.length) {
        for (let index = 0; index < availableProduct.length; index++) {
          const variant = availableProduct[index].attributes

          options.push({
            code: parseInt(availableProduct[index].id),
            label: variant.name.toUpperCase(),
            hasInventory: variant.availableInventoryCount > 0,
            image: variant.images.length
              ? variant.images[0].url
              : defaultNotFoundImage
          })
        }

        return options.filter(option => option.hasInventory)
      }
    },
    checkOptionsCount(option) {
      if (option.length > 0) {
        const key = Object.keys(option[0])
        const count = option[0][key].length
        return count
      } else {
        return 0
      }
    },
    getSelectedVarient(id, isEditEnabled) {
      const selectedVaritent = this.selected.find(x => x.id === id)
      if (selectedVaritent !== undefined && selectedVaritent.option) {
        if (isEditEnabled) {
          const values = Object.values(selectedVaritent.option)
            .flat()
            .filter(Boolean)
            .join(', ')
          return values
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.truncate {
  white-space: normal; /* Allow text wrapping */
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Add ellipsis (...) for overflow */
  max-width: 300px; /* Adjust this to control the visible length */
  display: -webkit-box; /* Support multiline ellipsis */
  -webkit-line-clamp: 3; /* Limit to 2 lines */
  -webkit-box-orient: vertical; /* Required for line clamping */
  cursor: pointer;
}
/* Optional: Tooltip styling if you want custom appearance */
.product-details [title] {
  position: relative;
}

.product-details [title]:hover::after {
  content: attr(title);
  position: absolute;
  top: -1.5rem; /* Position above the element */
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  white-space: normal;
  pointer-events: none;
  z-index: 10;
  display: none;
}
h2 {
  font-weight: 400;
  font-size: 2rem;
  color: #25282a;
}

.card-holder {
  width: 100%;

  .inner-card-holder {
    position: relative;

    &:hover ~ .product-details-container {
      .description {
        visibility: visible;
        opacity: 1;
      }
      .product-details:not(.description) {
        visibility: hidden;
        opacity: 0;
      }
    }
  }

  .product-details-container {
    position: relative;
    height: max-content;
  }

  .product-details {
    position: absolute;
    width: 100%;
    height: max-content;
    backface-visibility: hidden;
    padding: 1rem;
    display: flex;
    border: 1px solid #dfdad25d;
    border-top: none;
    border-left: none;
    border-bottom: 1px solid #dfdad25d;
    height: 98px;
    visibility: visible;
    opacity: 1;
    transition: visibility 0.3s, opacity 0.3s;

    @media (max-width: 575.98px) {
      height: 65px;
    }

    p {
      text-align: left;
      color: #232220;
      font-size: 0.753rem;
      font-family: $inter;
    }

    .name {
      width: 180px;
      margin-right: auto;
      font-size: 0.938rem;

      @media (max-width: 576px) {
        font-size: 0.75rem;
      }
    }

    span.font-bold {
      font-size: 0.75rem;
    }
    &.description {
      border-top: none;
      border-bottom: 1px solid #dfdad25d;
      position: relative;
      bottom: 0rem;
      overflow: hidden;
      word-wrap: break-word;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0.3s, opacity 0.3s;

      p {
        font-size: 0.893rem !important;
        @media (max-width: 576px) {
          font-size: 0.75rem !important;
        }
      }
    }
  }

  .inner-card-holder {
    height: 100%;
    width: 100%;
    cursor: pointer;
    border-right: 1px solid #dfdad2;
    border-bottom: 1px solid #dfdad2;
    padding: 1.25rem;
    transition: border 0.4s ease;

    &.active {
      //   border: 2px solid #232220;
    }

    .image-holder {
      margin-top: 1.25rem;
      height: 194px;
      margin-top: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 576px) {
        height: 144px;
      }

      img {
        width: 180px;
        height: 180px;
        object-fit: cover;
        aspect-ratio: 1/1;

        @media (max-width: 576px) {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}

.inactive {
  opacity: 0.6;
}

@media (max-width: 575.98px) {
  h2 {
    font-size: 1.5rem;
    line-height: 36px !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  h2 {
    font-size: 1.5rem;
    line-height: 36px !important;
  }
}

.checkbox-container-holder {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 1.3rem;
}

.checkmark {
  border-radius: 0 !important;
}
</style>
